import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  deleting: false,
  data: [],
  initialData: [],
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0
};

const realtimeCollectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_CLEAR:
      return {
        ...state,
        data: []
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.realtimeCollections],
        initialData: [...action.payload.realtimeCollections],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_SEARCH_FILTER:
      return {
        ...state,
        data: [
          ...state.initialData.filter((item) => {
            const searchTerm = action.payload.toUpperCase();
            if (!searchTerm) {
              return {
                ...state,
                data: [...state.initialData],
              };
            }
            return (
              item?.Rig?.toUpperCase().includes(searchTerm) ||
                item?.Well?.toUpperCase().includes(searchTerm) ||
                 item?.name?.toUpperCase().includes(searchTerm)
            );
          }),
        ],
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.REALTIME_COLLECTIONS_LIST_LOADING_FINISH:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};

export default realtimeCollectionsReducer;
